export function Logo({ variant = "light", compact = false }) {
  const textMain = variant === "light" ? "#F8FAFC" : "#0F172A";
  const textSub = variant === "light" ? "#CBD5E1" : "#64748B";
  return (
    <span className="inline-flex items-center gap-2.5" aria-label="North Ember Painting">
      <svg width="36" height="36" viewBox="0 0 48 48" fill="none" aria-hidden="true" className="shrink-0">
        <rect x="2" y="2" width="44" height="44" rx="12" fill="#0F172A" stroke="#F97316" strokeWidth="2" />
        <path
          d="M24 9c5.2 6.1 9.5 10.6 9.5 16a9.5 9.5 0 1 1-19 0c0-5.4 4.3-9.9 9.5-16z"
          fill="url(#ne-ember)"
        />
        <path d="M24 21c2.3 2.7 4 4.6 4 7a4 4 0 1 1-8 0c0-2.4 1.7-4.3 4-7z" fill="#FDE68A" />
        <defs>
          <linearGradient id="ne-ember" x1="24" y1="9" x2="24" y2="37" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F59E0B" />
            <stop offset="1" stopColor="#EA580C" />
          </linearGradient>
        </defs>
      </svg>
      {!compact && (
        <span className="leading-none">
          <span className="block font-display text-lg font-bold tracking-tight" style={{ color: textMain }}>
            North Ember
          </span>
          <span className="block text-[10px] font-semibold uppercase tracking-[0.32em]" style={{ color: textSub }}>
            Painting
          </span>
        </span>
      )}
    </span>
  );
}
